/** 10 MiB — must match backend MAX_UPLOAD_FILE_SIZE_BYTES */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const MAX_UPLOAD_FILE_SIZE_LABEL = '10MB';

export const MAX_UPLOAD_FILE_SIZE_ERROR = `File size must be less than ${MAX_UPLOAD_FILE_SIZE_LABEL}`;
